<template>
  <div>
    <div class="form-group row mb-4">
      <label for="state" class="col-form-label col-lg-2">
        {{ $t("tasks.create.form.state.text") }}
      </label>
      <div class="col-lg-10">
        <div v-html="showTaskStatus()"></div>
      </div>
    </div>

    <div class="form-group row mb-4">
      <label for="title" class="col-form-label col-lg-2">
        {{ $t("tasks.create.form.title.text") }}
      </label>
      <div class="col-lg-10">
        <input
          id="title"
          name="title"
          type="text"
          disabled
          :value="task.title"
          class="form-control"
        />
      </div>
    </div>

    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-2">{{ $t("tasks.create.form.description.text") }}</label>
      <div class="col-lg-10">
        <input
          id="description"
          name="description"
          type="text"
          disabled
          :value="task.description"
          class="form-control"
        />
      </div>
    </div>

    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-2">{{ $t("departments.name-singular") }}</label>
      <div class="col-lg-10">
        <input
          id="department"
          name="department"
          type="text"
          disabled
          :value="task.departmentName"
          class="form-control"
        />
      </div>
    </div>

    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-2">{{ $t("tasks.from") }}</label>
      <div class="col-lg-4">
        <input
          id="start-date"
          name="start-date"
          type="text"
          disabled
          :value="formatDate(task.startDate)"
          class="form-control"
        />
      </div>
      <label class="col-form-label col-lg-2 text-lg-right">{{ $t("tasks.to") }}</label>
      <div class="col-lg-4">
        <input
          id="end-date"
          name="end-date"
          type="text"
          disabled
          :value="formatDate(task.endDate)"
          class="form-control"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { taskService } from '@/helpers/services/tasks/taskService';
import { dateHelper } from '@/helpers/utils/dateHelper';
export default {
  name: "TaskDetails",
  props: {
    task: {
      required: true,
    },
  },
  methods: {
    formatDate(date) {
      return dateHelper.toGermanDateTime(date);
    },
    /**
     * The <span> tags are actually <b-badge> tags.
     * Unfortunatelly, they are not rendered correctly and therefore
     * we have to "transform" them directly into the corresponding <span> tags.
     * 
     * Same goes for styling, basic CSS is applied too late and therefore not working
     */
    showTaskStatus() {
      let badges = "";
      const allStates = taskService.getAllTaskStates();

      allStates.forEach((state, index, array) => {
        const isLastElement = (index === array.length - 2);

        let badgeClass;
        
        switch (state) {
          case "COMPLETED":
            // In case the task-state is completed, show the badge as success
            if (this.task.state === state) {
              badgeClass = "success";
            // otherwise handle it as normal badge
            } else {
              badgeClass = "light";
            }
            break;
          case "CANCELED":
            // In case the task-state is canceled, show the badge as danger
            if (this.task.state === state) {
              badgeClass = "danger";
            } else {
            // otherwise handle it as normal badge
              badgeClass = "light";
            }
            break;
          // In case the task-state is not COMPLETED or CANCELED,
          // show the badge as primary
          case this.task.state:
            badgeClass = "primary";
            break;
          // All states but the current one are light badges
          default:
            badgeClass = "light";
            break;
        }

        const beautifiedState = taskService.getBeautifiedTaskState(state);
        badges += `<span class="badge badge-${badgeClass}" style="font-size: 0.8rem;">${beautifiedState}</span>`;
        
        if (isLastElement) {
          badges += '<span style="font-size: 0.8rem;"> | </span>'
        } else if (state !== "CANCELED") {
          badges += '<i class="p-2 fa fa-arrow-right" aria-hidden="true"></i>';
        }
      });

      return badges;
    }
  }
}
</script>